import React, { useEffect } from 'react';
import {
    Switch,
    Route,
    BrowserRouter as Router,
} from 'react-router-dom';
import Home from '@containers/home';
import Detailed from '@containers/detailed';
import {
    getScarvesDataAPI,
    getContributorsDataAPI,
} from '@api/getScarvesData';
import { useDispatch, useSelector } from 'react-redux';
import {
    getContributorsListSuccess,
    getDataSuccess,
} from '@containers/app/actions';
import Header from '@containers/header';
import Footer from '@containers/footer';
import Loader from '@components/loader';
import AnimatedBackground from '@components/animatedBackground';

const App = () => {
    const dispatch = useDispatch();

    const scarvesData = useSelector(
        state => state.globalData.scarvesData
    );
    const contributorsList = useSelector(
        state => state.globalData.contributorsList
    );

    const isLoading =
        !scarvesData ||
        scarvesData.length === 0 ||
        !contributorsList ||
        Object.keys(contributorsList).length === 0;

    useEffect(() => {
        const fetchWithDelay = (apiCall, successAction) => {
            const startTime = Date.now();
            apiCall(data => {
                const elapsedTime = Date.now() - startTime;
                const remainingTime = Math.max(
                    0,
                    2000 - elapsedTime
                );
                setTimeout(() => {
                    successAction(data);
                }, remainingTime);
            }, console.log);
        };

        fetchWithDelay(
            getScarvesDataAPI,
            getDataSuccess(dispatch)
        );

        fetchWithDelay(
            getContributorsDataAPI,
            getContributorsListSuccess(dispatch)
        );
    }, [dispatch]);

    return (
        <Router>
            <AnimatedBackground />
            <div
                style={{ position: 'relative', zIndex: 1 }}
            >
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <Header />
                        <Switch>
                            <Route path="/:categorySlug">
                                <Detailed />
                            </Route>
                            <Route path="/">
                                <Home />
                            </Route>
                        </Switch>
                        <Footer />
                    </>
                )}
            </div>
        </Router>
    );
};

export default App;
